export default __webpack_public_path__ + "static/media/start.d8dd029f.svg";